export default "__VITE_ASSET__CBz0Kixb__"